module.exports = __webpack_public_path__ + "static/media/postgres.de71b010.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/postgres.png
// module id = 493
// module chunks = 0